import { Empty } from "antd";
import { FC } from "react";

interface Props {}

export const UnauthorizedPage: FC<Props> = () => {
  return <Empty description="You don't have access to report website." />;
};
